import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface PayrollDashboardSendReportDialogData {
  reportName: string;
}

export interface PayrollDashboardSendReportDialogResult {
  email: string;
}

@Component({
    selector: 'app-payroll-dashboard-send-report-dialog',
    templateUrl: './payroll-dashboard-send-report-dialog.component.html',
    styleUrls: ['./payroll-dashboard-send-report-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PayrollDashboardSendReportDialogComponent {
  protected readonly form = this.formBuilder.group({
    email: ['', [Validators.required, Validators.email]],
  });

  constructor(
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<PayrollDashboardSendReportDialogComponent, PayrollDashboardSendReportDialogResult>,
    @Inject(MAT_DIALOG_DATA) protected data: PayrollDashboardSendReportDialogData,
  ) {}

  protected cancel(): void {
    this.dialogRef.close();
  }

  protected submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const email = `${this.form.get('email')?.value || ''}`.trim();
    this.dialogRef.close({ email });
  }
}
